// This file was automatically generated from print.invoice.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.invoice');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.ptdata.model.note');
goog.require('el8.template.ptdata.patients');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.invoice.patientFacingContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.invoice._title(opt_data, output);
  el8.template.print.invoice._billTo(opt_data, output);
  el8.template.print.invoice._cptLineItems(soy.$$augmentData(opt_data, {includeDxs: false}), output);
  el8.template.print.invoice._paymentSiteDetails(opt_data, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.invoice.insuranceFacingContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.invoice._title(opt_data, output);
  output.append('<div class="clearfix"><div class="fr alignRight ml20">');
  el8.template.print.invoice._insurance(soy.$$augmentData(opt_data.patient.secondaryInsurance, {rank: 'Secondary'}), output);
  output.append('</div><div class="fr alignRight">');
  el8.template.print.invoice._insurance(soy.$$augmentData(opt_data.patient.primaryInsurance, {rank: 'Primary'}), output);
  output.append('</div>');
  el8.template.print.invoice._billTo(opt_data, output);
  output.append('</div>');
  el8.template.print.invoice._cptLineItems(soy.$$augmentData(opt_data, {includeDxs: true, icd10Only: opt_data.icd10Only, icd9Only: opt_data.icd9Only}), output);
  output.append((opt_data.bill.notes) ? '<div class="mt10"><p class="smallText el8Bold fl">Notes:</p><p class="normalText mlhalfin preserve">' + soy.$$escapeHtml(opt_data.bill.notes) + '</p></div>' : '', '<div class="mt10"><div class="alignRight"><p class="normalText">Seen by: ', soy.$$escapeHtml(opt_data.bill.visitSignPhysicianName), '</p>');
  var identifierList13427 = opt_data.bill.visitSignPhysicianIdentifiers;
  var identifierListLen13427 = identifierList13427.length;
  for (var identifierIndex13427 = 0; identifierIndex13427 < identifierListLen13427; identifierIndex13427++) {
    var identifierData13427 = identifierList13427[identifierIndex13427];
    output.append((identifierData13427.value) ? '<p class="normalText">' + soy.$$escapeHtml(identifierData13427.name) + ': ' + soy.$$escapeHtml(identifierData13427.value) + '</p>' : '');
  }
  output.append('<p class="normalText">Location: ', soy.$$escapeHtml(opt_data.bill.serviceLocation), '</p>', (opt_data.bill.serviceLocationPos) ? '<p class="normalText"> (POS: ' + ((opt_data.bill.serviceLocationPos < 10) ? '0' : '') + soy.$$escapeHtml(opt_data.bill.serviceLocationPos) + ' - ' + soy.$$escapeHtml(opt_data.bill.serviceLocationName) + ')</p>' : '', '</div>');
  if (opt_data.bill.visitSignDate) {
    el8.template.print.signature({esignatureUrl: opt_data.bill.esignatureUrl, signPhysicianName: opt_data.bill.visitSignPhysicianName, signDate: opt_data.bill.visitSignDate}, output);
  } else {
    output.append('<p class="pt10">Signature: ________________________________________________</p><br/>');
  }
  output.append('</div>');
  el8.template.print.invoice._paymentSiteDetails(opt_data, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.invoice._paymentSiteDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.paymentSiteUrl) ? '<div style="padding-top:40px;width:300px"><span class="normalText pt10 weightNormal">To make a payment visit: <br/><b>' + soy.$$escapeHtml(opt_data.paymentSiteUrl) + '</b><br/>by entering the website into your browser or pointing your mobile camera app at the code below:<br/><b><img width="100px" src="' + soy.$$escapeHtml(opt_data.paymentSiteQrCodeUrl) + '"/></span></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.invoice._title = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="mt40 mb20 el8Bold">Invoice<span class="normalText pt10 weightNormal fr">Invoice Date: ', (soy.$$escapeHtml(opt_data.bill.noteDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.bill.noteDate)) : ''), '</span></h1>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.invoice._billTo = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="relative plhalfin"><p class="smallText el8Bold el8BillToLabel">Bill to:</p><p class="largeText">');
  el8.template.ptdata.patients.displayName(opt_data.patient, output);
  output.append('</p><p class="largeText">', soy.$$escapeHtml(opt_data.patient.addressLine ? opt_data.patient.addressLine : ''), '</p><p class="largeText">', soy.$$escapeHtml(opt_data.patient.cityStateZip ? opt_data.patient.cityStateZip : ''), '</p><p class="largeText">D.O.B.: ', (soy.$$escapeHtml(opt_data.patient.dob)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.patient.dob)) : ''), '</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.invoice._cptLineItems = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table cellpadding="0" cellspacing="0" class="w100 el8InvoiceTable mt30"><tr><td class="normalText el8Bold w15">Date</td><td class="normalText el8Bold w55">Service</td><td class="normalText el8Bold w10">Units</td><td class="normalText el8Bold w10">Charge</td><td class="normalText el8Bold w10">Total</td></tr>');
  var cptObjList13487 = opt_data.bill.cpts;
  var cptObjListLen13487 = cptObjList13487.length;
  for (var cptObjIndex13487 = 0; cptObjIndex13487 < cptObjListLen13487; cptObjIndex13487++) {
    var cptObjData13487 = cptObjList13487[cptObjIndex13487];
    output.append('<tr><td>', (soy.$$escapeHtml(opt_data.bill.noteDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.bill.noteDate)) : ''), '</td><td><span class="el8Bold">');
    el8.template.ptdata.model.note.cptWithModifiers(cptObjData13487, output);
    output.append('</span>', (cptObjData13487.cptDescription) ? '<p>' + soy.$$escapeHtml(cptObjData13487.cptDescription) + '</p>' : '');
    if (opt_data.includeDxs && cptObjData13487.dxs.length) {
      output.append('<p class="pl10 smallText">Dx: ');
      if (opt_data.icd10Only && ! opt_data.icd9Only) {
        el8.template.ptdata.model.note.dxList(soy.$$augmentData(cptObjData13487, {isShowDualCoding: false}), output);
      } else if (! opt_data.icd10Only && opt_data.icd9Only) {
        el8.template.ptdata.model.note.dxList9Only(cptObjData13487, output);
      }
      output.append('</p>');
    }
    output.append('</td><td>', soy.$$escapeHtml(cptObjData13487.units ? cptObjData13487.units : '--'), '</td><td>', (cptObjData13487.charge) ? (soy.$$escapeHtml(cptObjData13487.charge)? el8.util.string.formatMoney(soy.$$escapeHtml(cptObjData13487.charge)) : '') : '--', '</td><td>', (cptObjData13487.subtotal) ? (soy.$$escapeHtml(cptObjData13487.subtotal)? el8.util.string.formatMoney(soy.$$escapeHtml(cptObjData13487.subtotal)) : '') : '--', '</td></tr>');
  }
  output.append((opt_data.bill.copayCollected && opt_data.bill.copayCollected.amount) ? '<tr class="el8LedgerLine"><td colspan="4" class="largeText el8Bold el8AlignRight"><p class="pt5">Total Charges:</p></td><td class="largeText el8Bold">' + (soy.$$escapeHtml(opt_data.bill.invoiceTotal)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.bill.invoiceTotal)) : '') + '</td></tr><tr><td colspan="4" class="largeText el8AlignRight"><p class="pt5">Payment Received:</p></td><td class="largeText">' + (soy.$$escapeHtml(opt_data.bill.copayCollected.amount)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.bill.copayCollected.amount)) : '') + '</td></tr>' : '<tr class="el8LedgerLine"><td colspan="4" class="largeText el8Bold el8AlignRight"><p class="pt6">Total Charges:</p></td><td class="largeText el8Bold ">' + (soy.$$escapeHtml(opt_data.bill.invoiceTotal)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.bill.invoiceTotal)) : '') + '</td></tr>', '</table>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.invoice._insurance = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.insuranceCompany) ? '<p class="normalText el8Bold">' + ((opt_data.rank) ? soy.$$escapeHtml(opt_data.rank) + ' ' : '') + 'Insurance</p><p class="normalText">' + soy.$$escapeHtml(opt_data.insuranceCompany.carrier) + ((opt_data.insurancePlan) ? ' ' + soy.$$escapeHtml(opt_data.insurancePlan.name) : '') + '</p>' + ((opt_data.groupId) ? '<p class="normalText">Group: ' + soy.$$escapeHtml(opt_data.groupId) + '</p>' : '') + ((opt_data.memberId) ? '<p class="normalText">Member: ' + soy.$$escapeHtml(opt_data.memberId) + '</p>' : '') : '');
  if (!opt_sb) return output.toString();
};
